export default {
  openapi: "3.0.0",

  servers: [
    {
      description: "mea API",
      url: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}`,
    },
  ],
  tags: [
    {
      name: "Address",
    },
  ],
  paths: {
    "/address": {
      get: {
        tags: ["Address"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "get address",
        parameters: [
          {
            in: "query",
            name: "api_key",
            description: "Enter your api key.  ",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            required: true,
            name: "search",
            description: "search",
            schema: {
              type: "string",
              example: "1034 วชิรธรรมสาธิต",
            },
          },
        ],
        responses: {
          200: {
            description: "Example results",
            content: {
              "application/json": {
                schema: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      _id: {
                        type: "string",
                      },
                      house_no: {
                        type: "string",
                      },
                      moo_village: {
                        type: "string",
                      },
                      soi: {
                        type: "string",
                      },
                      street: {
                        type: "string",
                      },
                      sub_distinct: {
                        type: "string",
                      },
                      district: {
                        type: "string",
                      },
                      province: {
                        type: "string",
                      },
                      postcode: {
                        type: "string",
                      },
                      keyword: {
                        type: "string",
                      },
                      score: {
                        type: "number",
                        format: "float",
                      },
                    },
                  },
                },
                example: [
                  {
                    _id: "0041021660",
                    house_no: "1034",
                    moo_village: "",
                    floor: "",
                    soi: "ซ.วชิรธรรมสาธิต",
                    street: "สุขุมวิท",
                    sub_distinct: "",
                    district: "",
                    province: "",
                    postcode: "10260",
                    keyword: "1034   ซ.วชิรธรรมสาธิต สุขุมวิท    10260",
                    score: 229.44565,
                  },
                  {
                    _id: "0010001702",
                    house_no: "1034",
                    moo_village: "",
                    floor: "",
                    soi: "",
                    street: "ถ.ทรงวาด",
                    sub_distinct: "แขวงจักรวรรดิ์",
                    district: "สัมพันธวงศ์",
                    province: "",
                    postcode: "10100",
                    keyword:
                      "1034    ถ.ทรงวาด แขวงจักรวรรดิ์ สัมพันธวงศ์  10100",
                    score: 135.12343,
                  },
                  {
                    _id: "0020029798",
                    house_no: "1034",
                    moo_village: "",
                    floor: "",
                    soi: "ซ.ตากสิน 4",
                    street: "",
                    sub_distinct: "แขวงบางยี่เรือ",
                    district: "",
                    province: "กรุงเทพมหานคร",
                    postcode: "10600",
                    keyword:
                      "1034   ซ.ตากสิน 4  แขวงบางยี่เรือ  กรุงเทพมหานคร 10600",
                    score: 135.12343,
                  },
                ],
              },
            },
          },
        },
      },
    },
    "/address/{id}": {
      get: {
        tags: ["Address"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "get address detail by id.",
        parameters: [
          {
            in: "query",
            name: "api_key",
            description: "Enter your api key.  ",
            schema: {
              type: "string",
            },
          },
          {
            in: "path",
            required: true,
            name: "id",
            description: "id",
            schema: {
              type: "string",
              example: "0041021660",
            },
          },
        ],
        responses: {
          200: {
            description: "Example results",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    house_no: {
                      type: "string",
                    },
                    moo_village: {
                      type: "string",
                    },
                    soi: {
                      type: "string",
                    },
                    street: {
                      type: "string",
                    },
                    sub_distinct: {
                      type: "string",
                    },
                    district: {
                      type: "string",
                    },
                    province: {
                      type: "string",
                    },
                    lat: {
                      type: "number",
                      format: "double",
                    },
                    lon: {
                      type: "number",
                      format: "double",
                    },
                  },
                },
                example: {
                  house_no: "1034",
                  moo_village: "",
                  floor: "",
                  soi: "ซ.วชิรธรรมสาธิต",
                  street: "สุขุมวิท",
                  sub_distinct: "",
                  district: "",
                  province: "",
                  postcode: "10260",
                  lat: 13.68299814,
                  lon: 100.62652242,
                },
              },
            },
          },
        },
      },
    },
  },
  components: {
    securitySchemes: {
      ApiKeyAuth: {
        type: "apiKey",
        in: "query",
        name: "api_key",
        description: "Enter your API Key.",
      },
    },
  },
};
